import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72e4e76c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex pl-2 pt-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Membership Level")
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Your account is currently on the ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Level. You hold ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Notifi tokens. ")
const _hoisted_7 = { class: "pt-3" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" To enable access to more items below ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Swap")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Avalanche tokens for Notifi tokens and keep them in your wallet. ")
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Cost Summary:")
], -1))
const _hoisted_13 = { class: "row userCostsSummary" }

import { onMounted, ref } from "vue";
import UserWallets from "@/components/UserWallets.vue";
import UserCostsSummary from "@/components/UserCostsSummary.vue";
import { useUserStore } from "@/store/pinia_user";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();

onMounted(() => {
  userStore.fetchUserTokens();
});

const openSwap = (): void => {
  window.open("https://app.pangolin.exchange/#/swap");
};

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, [
        _hoisted_4,
        _createElementVNode("strong", null, _toDisplayString(_unref(userStore).currentLevel), 1),
        _hoisted_5,
        _createElementVNode("strong", null, _toDisplayString(_unref(userStore).NotifiTokens), 1),
        _hoisted_6
      ]),
      _createElementVNode("p", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_va_button, {
          onClick: openSwap,
          size: "small",
          color: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _hoisted_10
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(UserWallets)
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createVNode(UserCostsSummary, {
        balance: _unref(userStore).NotifiTokens
      }, null, 8, ["balance"])
    ])
  ]))
}
}

})